module.exports = __webpack_public_path__ + "img/bg07.6840e48a.jpg";